export default "__VITE_ASSET__BrYR4PLR__"